import { useQuery } from '@tanstack/react-query';
import baseFetcher from 'shared/helpers/baseFetcher';
import { APIKey, apiRoutes } from 'constants/apiKeys';

interface DocumentMetadata {
  url: string;
  title: string;
  publication_date?: string;
  language?: string;
  parent?: {
    id?: string;
    use_source_url?: boolean;
  };
  source_url?: string;
}

export function useDocumentDownload(id?: string, queryString?: string) {
  return useQuery<string>({
    queryKey: [APIKey.DOCUMENT_DOWNLOAD, { id }],
    queryFn: async () => {
      const blob = await baseFetcher(
        `${apiRoutes.documentDownload(id)}${queryString}`,
        {
          removeHeaders: ['Accept'],
        }
      );
      return window.URL.createObjectURL(blob);
    },
    enabled: !!id,
  });
}

export function useDocument(id?: string, queryString?: string) {
  return useQuery<DocumentMetadata>({
    queryKey: [APIKey.DOCUMENT, { id }],
    queryFn: () => baseFetcher(`${apiRoutes.document(id)}${queryString}`),
    enabled: !!id,
  });
}
